import type {RemoteSteerableItem} from '../../../types/events'
import {RemoteSteeringEnabledEntry} from '../RemoteSteeringEnabledEntry'

/**
 * Renders a "Remote mode enabled/disabled" notice in the timeline.
 */
export function RemoteSteerable({item}: {item: RemoteSteerableItem}) {
  if (!item.enabled) return null

  return <RemoteSteeringEnabledEntry />
}
